<template>
  <div
    class="h-screen login-page-css flex w-full vx-row no-gutter items-center justify-center"
    id="page-login"
  >

      <!--<img src="../../assets/images/auth_bg.jpg" class="bg_image" />-->
      <vx-card class="rounded-xl overflow-hidden m-6 border border-solid login-card-container" style="border-radius: 20px !important; max-width:1000px; overflow: hidden !important">
        <div slot="no-body" class="">
          <div class="grid lg:grid-cols-5 no-gutter justify-center main_wrapper">
            <div class="md:col-span-2 left_sidebox hidden lg:block">
              <div class="flex justify-center items-center flex-col h-full p-8">
                <div class="flex justify-center items-center mb-8">
                  <img src="/img/sangat-logo.8fc4d220.png" alt="login" class="mx-auto img_wrapper w-[100px] h-[100px]" style="border-radius: 20px; overflow: hidden; width: 100px; height: 100px" />
                </div>
                <h2 class="text-white mb-4">Sat Sri Akal! {{ tempName }}</h2>
                <p class="text-white pt-4 text-center text-lg">
                  {{ this.today_note }}
                </p>
                <p class="text-white text-lg pt-2 text-center font-bold">-{{ author }}</p>
                <div class="text-white bottom_text">Powered by <span class="font-bold uppercase">Sangat ™</span></div>
              </div>
            </div>

            <div class="md:col-span-3 sm:w-full lg:w-full d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <div class="lg:hidden flex justify-left items-left mb-8">
                    <img src="/img/sangat-logo.8fc4d220.png" alt="login" class="img_wrapper" style="border-radius: 20px; width: 40px; height: 90px" />
                  </div>
                  <h1 class="mb-4">Welcome Back To Sangat</h1>
                  <p class="text-lg">To access the Sangat™ admin portal, please log in with your secure credentials.</p>
                </div>
                <form v-if="!otpPage" action="" @submit.prevent="save_changes">
                  <div class="vx-row pt-5 px-5">
                    <div class="vx-col w-full">
                      <div class="vx-row mb-2">
                        <label class="text-lg" for="email">Email</label>
                        <vs-input
                          id="email"
                          class="w-full"
                          type="email"
                          v-validate="'required'"
                          name="email"
                          icon-no-border
                          icon="icon icon-user"
                          icon-pack="feather"
                          v-model="email"
                          placeholder="Enter Email"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                      </div>

                      <div class="vx-row mt-5 mb-2">
                        <label for="Password" class="text-lg">Password</label>
                        <vx-input-group class="w-full">
                          <vs-input
                            placeholder="Enter Password"
                            v-validate="'required'"
                            :type="!showNewPassword && 'password'"
                            name="password"
                            icon-no-border
                            icon="icon icon-lock"
                            icon-pack="feather"
                            v-model="password"
                            class="w-full"
                          />
                          <template slot="append">
                            <div class="append-text btn-addon" style="height: 60px">
                              <vs-button
                                style="height: 60px !important; width: 80px !important"
                                icon-pack="feather"
                                :icon="showNewPassword ? 'icon icon-eye' : 'icon icon-eye-off'"
                                @click="showNewPassword = !showNewPassword"
                              />
                            </div>
                          </template>
                          <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
                        </vx-input-group>
                      </div>
                      <!-- Forgot Password Link -->
                      <div class="mt-4 text-right">
                        <router-link to="/forgot-password">Forgot Password?</router-link>
                      </div>
                      <div v-if="!skipRecaptcha && captchaSiteKey" class="vx-row mt-5 mb-2 recaptcha-wrapper">
                        <vue-recaptcha
                          ref="recaptcha"
                          @verify="onVerify"
                          @expired="onExpired"
                          :sitekey="captchaSiteKey"
                          :load-recaptcha-script="true"
                        />
                      </div>
                    </div>
                    <div class="flex mt-4 justify-between items-center gap-2 w-full">
                      <vs-button style="padding: 20px 60px" class="w-full mt-3 items-center vs-con-loading__container" color="success" id="login-user" @click="save_changes">Login</vs-button>
                      <!-- <router-link to="/forget-password">Forgot Password?</router-link> -->
                    </div>
                  </div>
                </form>
                <div v-else>
                  <otp-verify :email="email" :otpPage="otpPage" @back-to-login="otpPage = false" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import OtpVerify from './OtpVerify.vue' // Adjust path as needed

export default {
  // Form Data
  data() {
    return {
      email: null,
      password: null,
      tempName: 'Sangat',
      showNewPassword: false,
      loading: false,
      today_note: null,
      author: null,
      motivationNotes: [
        { text: 'ਮੇਹਨਤ ਤੋਂ ਬਿਨਾ ਕੋਈ ਵੀ ਕੰਮ ਸਫਲ ਨਹੀਂ ਹੁੰਦਾ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਹਾਰ ਨਾ ਮੰਨ, ਕਿਉਂਕਿ ਸਫਲਤਾ ਨੇਹਰੇ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਸ ਦਿਨ ਤੁਹਾਨੂੰ ਆਪਣੇ ਸਪਨਿਆਂ ਦੇ ਪਿੱਛੇ ਦੌੜਣ ਦਾ ਹੋਸਲਾ ਮਿਲ ਜਾਂਦਾ ਹੈ, ਉਸ ਦਿਨ ਜਿੰਦਗੀ ਬਦਲ ਜਾਂਦੀ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਮਿਹਨਤ ਕਰ, ਕਿਉਂਕਿ ਮਿਹਨਤ ਦਾ ਕੋਈ ਮੋਲ ਨਹੀਂ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਦਿਲੋਂ ਮਹਨਤ ਕਰਦਾ ਹੈ, ਉਹੀ ਸਭ ਕੁਝ ਪਾਉਂਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਸਫਲਤਾ ਉਹੀ ਪਾਉਂਦਾ ਹੈ ਜੋ ਹਾਰ ਨਹੀਂ ਮੰਨਦਾ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਸਪਨੇ ਉਹ ਨਹੀਂ ਜੋ ਅਸੀਂ ਸੌਂਦੇ ਸਮੇਂ ਵੇਖਦੇ ਹਾਂ, ਸਪਨੇ ਉਹ ਹਨ ਜੋ ਸਾਨੂੰ ਸੌਣ ਨਹੀਂ ਦਿੰਦੇ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਹੋਸਲਾ ਰੱਖੋ, ਕਮਜ਼ੋਰੀ ਨੂੰ ਮਾਤ ਦਿਓ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਸਫਲਤਾ ਦੀ ਚਾਬੀ ਸਿਰਫ ਮਿਹਨਤ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਆਪਣੇ ਮੰਜ਼ਿਲ ਨੂੰ ਪਾਉਣ ਲਈ ਹਮੇਸ਼ਾ ਅੱਗੇ ਵਧਦੇ ਰਿਹਾ ਕਰੋ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਵੀ ਸਫਲ ਹੋਣਾ ਚਾਹੁੰਦਾ ਹੈ, ਉਹ ਆਪਣੀ ਕਮਜ਼ੋਰੀ ਨੂੰ ਤਿਆਗ ਦਿੰਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਵੱਡੇ ਸੁਪਨੇ ਦੇਖੋ ਅਤੇ ਉਨ੍ਹਾਂ ਨੂੰ ਪਾਉਣ ਲਈ ਮਿਹਨਤ ਕਰੋ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿੰਦਗੀ ਵਿੱਚ ਕੁਝ ਵੀ ਪਾਉਣ ਲਈ ਦਿਲੋਂ ਮਹਨਤ ਕਰੋ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਹਾਰਦਿਆਂ ਵੀ ਹਾਰ ਨਹੀਂ ਮੰਨਦਾ, ਉਹੀ ਅਸਲ ਸਫਲਤਾ ਪ੍ਰਾਪਤ ਕਰਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਮੇਹਨਤ ਕਦੇ ਵੀ ਵੈਰਥ ਨਹੀਂ ਜਾਂਦੀ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿੰਦਗੀ ਵਿੱਚ ਕਦੇ ਵੀ ਹਾਰ ਨਾ ਮੰਨੋ, ਸਫਲਤਾ ਜਰੂਰ ਮਿਲੇਗੀ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਹਰ ਇੱਕ ਦਿਨ ਨਵੀਂ ਸ਼ੁਰੂਆਤ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਵੀ ਮਹਨਤ ਕਰਦਾ ਹੈ, ਉਹੀ ਸਫਲ ਹੁੰਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਸੋਚਣ ਨਾਲ ਹੀ ਨਹੀਂ, ਮਿਹਨਤ ਕਰਨ ਨਾਲ ਹੀ ਸਫਲਤਾ ਮਿਲਦੀ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਮਨਜ਼ਿਲ ਨੂੰ ਪਾਉਣ ਲਈ ਸੱਚੀ ਮਿਹਨਤ ਕਰਦਾ ਹੈ, ਉਹੀ ਕਾਮਯਾਬ ਹੁੰਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਆਪਣੇ ਕੰਮ ਨਾਲ ਪਿਆਰ ਕਰਦਾ ਹੈ, ਉਹੀ ਸਫਲ ਹੁੰਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਸਫਲਤਾ ਉਹੀ ਮਿਲਦੀ ਹੈ, ਜਿਹੜਾ ਆਪਣੇ ਮੰਜ਼ਿਲ ਤੋਂ ਕਦੇ ਵੀ ਮੁੜਦਾ ਨਹੀਂ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਵੀ ਮਿਹਨਤ ਕਰਦਾ ਹੈ, ਉਹੀ ਆਪਣੀ ਮੰਜ਼ਿਲ ਪਾਉਂਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਮਿਹਨਤ ਨੂੰ ਆਪਣਾ ਦੋਸਤ ਬਣਾ ਲਵੋ, ਸਫਲਤਾ ਆਪਣੇ ਆਪ ਮਿਲ ਜਾਵੇਗੀ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਕਦੇ ਹਾਰ ਨਹੀਂ ਮੰਨਦਾ, ਉਹੀ ਸਫਲ ਹੋ ਜਾਂਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਵੀ ਜਿੰਦਾ ਹੈ, ਉਹ ਮਿਹਨਤ ਨਾਲ ਜਿੰਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਸਫਲਤਾ ਦਾ ਰਸਤਾ ਹਮੇਸ਼ਾ ਮਿਹਨਤ ਤੋਂ ਹੋ ਕੇ ਹੀ ਗੁਜਰਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਵੀ ਆਪਣੀ ਮੰਜ਼ਿਲ ਨੂੰ ਪਾਉਣ ਲਈ ਸੱਚੇ ਦਿਲ ਨਾਲ ਮਿਹਨਤ ਕਰਦਾ ਹੈ, ਉਹੀ ਸਫਲ ਹੁੰਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਮਿਹਨਤ ਕਦੇ ਵੀ ਫਜੂਲ ਨਹੀਂ ਜਾਂਦੀ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਵੀ ਮਿਹਨਤ ਕਰਦਾ ਹੈ, ਉਹ ਆਪਣੀ ਮੰਜ਼ਿਲ ਜਰੂਰ ਪਾਉਂਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਸਫਲਤਾ ਉਹੀ ਮਿਲਦੀ ਹੈ, ਜਿਹੜਾ ਕਦੇ ਹਾਰ ਨਹੀਂ ਮੰਨਦਾ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਆਪਣੇ ਕੰਮ ਨਾਲ ਪਿਆਰ ਕਰਦਾ ਹੈ, ਉਹੀ ਕਾਮਯਾਬ ਹੁੰਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਸਪਨਾ ਉਹ ਨਹੀਂ ਜੋ ਸੌਂਦੇ ਸਮੇਂ ਦੇਖਿਆ ਜਾਵੇ, ਸਪਨਾ ਉਹ ਹੈ ਜੋ ਸਾਨੂੰ ਸੌਣ ਨਾ ਦੇਵੇ।', author: 'ਅਬਦੁਲ ਕਲਾਮ' },
        { text: 'ਸਫਲਤਾ ਉਹੀ ਪਾਉਂਦਾ ਹੈ ਜੋ ਆਪਣੇ ਸਪਨਿਆਂ ਨੂੰ ਹਕੀਕਤ ਬਣਾਉਂਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਮਿਹਨਤ ਕਰ ਅਤੇ ਕਦੇ ਵੀ ਹਾਰ ਨਾ ਮੰਨ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਸਫਲਤਾ ਦਾ ਰਸਤਾ ਹਮੇਸ਼ਾ ਮਿਹਨਤ ਤੋਂ ਹੋ ਕੇ ਹੀ ਲੰਘਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਆਪਣੇ ਕੰਮ ਨਾਲ ਪਿਆਰ ਕਰੋ, ਸਫਲਤਾ ਆਪਣੇ ਆਪ ਮਿਲੇਗੀ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਮਿਹਨਤ ਕਦੇ ਵੀ ਫਜੂਲ ਨਹੀਂ ਜਾਂਦੀ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਹੋਸਲਾ ਰੱਖੋ, ਕਮਜ਼ੋਰੀ ਨੂੰ ਮਾਤ ਦਿਓ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਸਫਲਤਾ ਉਹੀ ਪਾਉਂਦਾ ਹੈ ਜੋ ਆਪਣੇ ਮੰਜ਼ਿਲ ਤੋਂ ਕਦੇ ਵੀ ਮੁੜਦਾ ਨਹੀਂ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਮੇਹਨਤ ਨਾਲ ਜਿੰਦਗੀ ਨੂੰ ਸਵਾਰੋ, ਸਫਲਤਾ ਆਪਣੇ ਆਪ ਮਿਲੇਗੀ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਸੱਚੀ ਮਿਹਨਤ ਕਦੇ ਵੀ ਬੇਕਾਰ ਨਹੀਂ ਜਾਂਦੀ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਹੋਸਲਾ ਕਦੇ ਵੀ ਨਾ ਛੱਡੋ, ਸਫਲਤਾ ਜਰੂਰ ਮਿਲੇਗੀ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਦਿਲੋਂ ਮਹਨਤ ਕਰਦਾ ਹੈ, ਉਹੀ ਸਫਲ ਹੁੰਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਜਿਹੜਾ ਵੀ ਸਫਲ ਹੋਣਾ ਚਾਹੁੰਦਾ ਹੈ, ਉਹ ਆਪਣੀ ਕਮਜ਼ੋਰੀ ਨੂੰ ਤਿਆਗ ਦਿੰਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਮੇਹਨਤ ਨਾਲ ਹਰ ਇੱਕ ਕੰਮ ਨੂੰ ਸਫਲ ਬਣਾਇਆ ਜਾ ਸਕਦਾ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਹਮੇਸ਼ਾ ਆਪਣੀ ਮੰਜ਼ਿਲ ਨੂੰ ਯਾਦ ਰੱਖੋ ਅਤੇ ਉਸ ਪਾਸੇ ਅੱਗੇ ਵਧਦੇ ਰਹੋ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਸਫਲਤਾ ਉਹੀ ਮਿਲਦੀ ਹੈ ਜੋ ਹਾਰ ਨਹੀਂ ਮੰਨਦਾ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਸੋਚਣ ਨਾਲ ਨਹੀਂ, ਮਿਹਨਤ ਕਰਨ ਨਾਲ ਸਫਲਤਾ ਮਿਲਦੀ ਹੈ।', author: 'ਅਣਜਾਣ' },
        { text: 'ਆਪਣੇ ਸਪਨਿਆਂ ਨੂੰ ਪਾਉਣ ਲਈ ਦਿਲੋਂ ਮਹਨਤ ਕਰੋ।', author: 'ਅਣਜਾਣ' }
      ],
      captchaSiteKey: (process.env.VUE_APP_GOOGLE_CAPTCHA_SITE_KEY || '').trim(),
      recaptchaResponse: null,
      skipRecaptcha: false,
      otpPage: false // For toggling between login and OTP steps
    }
  },

  /* Components */
  components: {
    OtpVerify
  },

  /* Form Validate */
  computed: {
    validateForm() {
      return !this.errors.any()
    }
  },
  /* API Calling Function */
  methods: {
    ...mapActions('auth', { login: 'login' }),

    onVerify(response) {
      this.recaptchaResponse = response
    },

    onExpired() {
      this.recaptchaResponse = null
    },

    resetRecaptcha() {
      this.recaptchaResponse = null
      if (!this.skipRecaptcha && this.$refs.recaptcha) {
        this.$refs.recaptcha.reset()
      }
    },

    async save_changes() {
      if (this.loading) return false
      if (!this.skipRecaptcha && !this.recaptchaResponse) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please complete the reCAPTCHA verification',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      this.loading = true
      try {
        const payload = {
          email: this.email,
          password: this.password
        }
        if (!this.skipRecaptcha) {
          payload.recaptcha = this.recaptchaResponse
        }
        const { success } = await this.login(payload)
        this.loading = false
        if (success) {
          this.otpPage = true // Show OTP verification component
        } else {
          this.$router.push({ name: 'home' })
        }
      } catch (message) {
        this.loading = false
        this.resetRecaptcha()
        this.$vs.notify({
          title: 'Error',
          text: message.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    }
  },
  /* API Calling Loading */
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#login-user',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#login-user > .con-vs-loading')
      }
    }
  },

  mounted() {
    const random = this.motivationNotes.sort(func)
    this.today_note = random[0].text
    this.author = random[0].author
    function func(a, b) {
      return 0.5 - Math.random()
    }
    this.tempName = localStorage.getItem('userName')
  }
}
</script>

<style lang="scss">
.bg_image {
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.left_sidebox {
  background-color: rgba(var(--vs-primary), 1);
}

.main_wrapper {
  min-height: 500px;
  height: 100%;
  max-width: 1000px;
}

.img_wrapper {
  height: 100%;
  width: 100%;
  min-width: 95px;
}

.login-tabs-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.bottom_text {
  position: absolute;
  bottom: 20px;
}

.recaptcha-wrapper {
  min-height: 78px;
  overflow: visible;
}
</style>
